function encode(input) {
  return encodeURIComponent(input).replace(/'/g, '%27');
}

window.phpModule = {};

let output = '';

const phpModuleOptions = {
  postRun() {
    vue.$emit('php.loaded');
  },
  print(...lines) {
    const outputCode = lines.join(' ');
    output += outputCode + "\n";
  },
  printErr(...lines) {
    const error = lines.join(' ');
    output += error + "\n";
  },
};

window.phpModule = PHP(phpModuleOptions);

vue.$on('php.run.request', (method, url) => {
    const controllerCode = vue.$store.state.Code.controller;
    const viewCode = vue.$store.state.Code.view;

    output = '';
    const code = `$phar = 'phar://laravel.phar';require $phar . '/index.php';tinkerwell_http('${encode(controllerCode)}', '${encode(viewCode)}', '${method}', '${url}');`;
    const ret = phpModule.ccall('pib_eval', 'number', ['string'], [code]);

    vue.$store.dispatch('setOutput', output);

    vue.$emit('php.print', output);
});

vue.$on('php.run.tinkerwell', () => {
  const mode = vue.$store.state.Code.mode;

  if (mode === 'cli') {
    const inputCode = vue.$store.state.Code.code;

    output = '';
    const code = `$phar = 'phar://laravel.phar';require $phar . '/index.php';tinkerwell('${encode(inputCode)}');`;
    const ret = phpModule.ccall('pib_eval', 'number', ['string'], [code]);

    vue.$store.dispatch('setOutput', output);

    vue.$emit('php.print', output);
  }

  if (mode === 'http') {
    const controllerCode = vue.$store.state.Code.controller;
    const viewCode = vue.$store.state.Code.view;

    output = '';
    const code = `$phar = 'phar://laravel.phar';require $phar . '/index.php';tinkerwell_http('${encode(controllerCode)}', '${encode(viewCode)}');`;
    const ret = phpModule.ccall('pib_eval', 'number', ['string'], [code]);

    vue.$store.dispatch('setOutput', output);

    vue.$emit('php.print', output);
  }
});
